import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course02 from "../../../course/course-02/course";
import lesson0212 from "../../../lesson/course-02/lesson-12/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "4a46fbe6-754f-4036-aa25-b4663556ca7b",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0212),
    lesson: lesson0212,
  },
];

export default lessonLinks;
